export default "__VITE_ASSET__e58afd4a__"